import { Link } from "react-router-dom";
import "./LastPerformance.css";

const MIN_AVG = 8;
const THRESHOLD = 0.5;

// Players of this game whose last game (this season) was 50%+ above or below their season points average.
export function lastPerformance(rows) {
  const out = [];
  for (const r of rows) {
    const avg = r.recent?.avg?.pts;
    const last = r.recent?.games?.at(-1);
    if (!avg || avg < MIN_AVG || !last) continue;
    const diff = (last.pts - avg) / avg;
    if (Math.abs(diff) < THRESHOLD) continue;
    // Consecutive latest games beyond ±50% in the same direction.
    let streak = 0;
    for (const g of [...r.recent.games].reverse()) {
      const d = (g.pts - avg) / avg;
      if (Math.abs(d) >= THRESHOLD && Math.sign(d) === Math.sign(diff)) streak += 1;
      else break;
    }
    out.push({ r, avg, last, diff, streak });
  }
  return { up: out.filter((x) => x.diff > 0).sort((a, b) => b.diff - a.diff), down: out.filter((x) => x.diff < 0).sort((a, b) => a.diff - b.diff) };
}

const when = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short" });

function Item({ x, tone }) {
  const { r, avg, last, diff, streak } = x;
  return (
    <Link to={`/player/${r.player_id}`} className={`lp-row ${tone}`} data-testid={`last-perf-${r.player_id}`}>
      <span className="lp-photo">{r.photo && <img src={r.photo} alt="" loading="lazy" />}
        {streak >= 2 && <em className="lp-streak" title={`${streak} games in a row ${diff > 0 ? "+" : "−"}50%`} data-testid={`last-perf-streak-${r.player_id}`}>STR {streak}</em>}
      </span>
      <span className="lp-who">
        <strong>{r.name}</strong>
        <small><img src={r.team_logo} alt="" />{r.team} · last: {last.home ? "vs" : "@"} {last.opp} · {when(last.date)} · {last.min} MIN</small>
      </span>
      <span className="lp-num"><small>SEASON AVG</small><b>{avg.toFixed(1)}</b></span>
      <span className="lp-arrow">→</span>
      <span className="lp-num lp-last"><small>LAST GAME</small><b data-testid={`last-perf-pts-${r.player_id}`}>{last.pts}</b></span>
      <span className="lp-diff" data-testid={`last-perf-diff-${r.player_id}`}>{diff > 0 ? "+" : ""}{Math.round(diff * 100)}%</span>
    </Link>
  );
}

function Group({ title, sub, items, tone, id }) {
  return (
    <section className={`lp-group ${tone}`} data-testid={`last-perf-${id}`}>
      <h3><i />{title}<small>{sub}</small><em>{items.length}</em></h3>
      {items.length ? items.map((x) => <Item key={x.r.player_id} x={x} tone={tone} />) : <p className="lp-empty">No players.</p>}
    </section>
  );
}

export function LastPerformance({ rows, game }) {
  if (!game) return <p className="tv-empty">Select a game.</p>;
  const { up, down } = lastPerformance(rows.filter((r) => r.game_id === game.id));
  return (
    <div className="lp-root" data-testid="last-performance">
      <p className="lp-intro">Last game points vs season average · players averaging {MIN_AVG}+ PTS · {game.away_code} @ {game.home_code}</p>
      <Group id="up" tone="is-up" title="+50% OR MORE" sub="Scored well above their average" items={up} />
      <Group id="down" tone="is-down" title="−50% OR MORE" sub="Scored well below their average" items={down} />
    </div>
  );
}
